import Request from "../../shared/utils/_request";

class Office {
  constructor() {}
  //组织架构
  getTree() {
    return Request.post("/account/office/get-tree");
  }
  create(payload) {
    return Request.post("/account/office/create", payload);
  }
  update(payload) {
    return Request.post("/account/office/update", payload);
  }
  enableDelete(payload) {
    return Request.post("/account/office/enableDelete", payload);
  }
  delete(payload) {
    return Request.post("/account/office/delete", payload);
  }
  //员工
  getUserList(payload) {
    return Request.post("/account/get-list", payload);
  }
  getUserDetail(payload) {
    return Request.post("/account/get-user", payload);
  }
  deleteUser(payload) {
    return Request.post("/account/delete", payload);
  }
  updateUser(payload) {
    return Request.post("/account/update", payload);
  }
  createUser(payload) {
    return Request.post("/account/create", payload);
  }
  changeUserStatus(payload) {
    return Request.post("/account/change-status", payload);
  }
}

export const office = new Office();
